import { UUID } from "../../../utils/typeDefinitions";
import IBimVisualizerApiProvider from "../IBimVisualizerApiProvider";
import ApiApartmentDocumentProvider from "../../documentProvider/ApiApartmentDocumentProvider";
import StartupProjectApiDataLoader from "./StartupProjectApiDataLoader";

class ApartmentAppDataProvider extends StartupProjectApiDataLoader  {
    apartmentGlobalId: UUID;

    constructor(apiProvider: IBimVisualizerApiProvider, projectGlobalId: UUID, apartmentGlobalId: UUID) {
        super(apiProvider, new ApiApartmentDocumentProvider(projectGlobalId, apartmentGlobalId, apiProvider), projectGlobalId);
        this.apartmentGlobalId = apartmentGlobalId;
    }

    // Load spatial structure model
    loadRootProduct = async () => {
        const result = await this.apiProvider.getApartmentModelByGlobalIds(this.projectGlobalId, this.apartmentGlobalId);
        return result;
    }
    
}

export default ApartmentAppDataProvider;